export default __webpack_public_path__ + "static/media/(49).13543ed2.jpg";